'use client'

import React, { ReactNode } from 'react'

import { ApolloProvider } from '@apollo/client'

import { createApolloClient } from 'Services/Apollo'

const apolloClient = createApolloClient()

export function ApolloClientProvider({ children }: { children: ReactNode }) {
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
